/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { I18n } from "@aws-amplify/core";
import AmplifyVerifyContact from "aws-amplify-react/lib/Auth/VerifyContact";
import { AuthShell, withInlineAuthError } from "./AuthFormShared";
import { VerifyContactFormView } from "./AuthFormViews";

const VerifyContactBase: any = withInlineAuthError(AmplifyVerifyContact);

export class VerifyContact extends VerifyContactBase {
    showComponent() {
        const { authData, hide } = this.props;
        if (hide && hide.includes(VerifyContact)) {
            return null;
        }

        const unverified = authData?.unverified ?? {};
        const hasVerifyAttr = Boolean(this.state.verifyAttr);

        return (
            <AuthShell
                title={I18n.get(
                    "Account recovery requires verified contact information",
                )}
            >
                <VerifyContactFormView
                    error={this.state.authError}
                    mode={hasVerifyAttr ? "code" : "select"}
                    onFieldChange={this.handleInputChange}
                    onSkip={() => this.changeState("signedIn", authData)}
                    onSubmit={event => {
                        event.preventDefault();
                        if (hasVerifyAttr) {
                            this.submit();
                        } else {
                            this.verify();
                        }
                    }}
                    showEmail={Boolean(unverified.email)}
                    showPhone={Boolean(unverified.phone_number)}
                />
            </AuthShell>
        );
    }
}

export default VerifyContact;
